import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    height: 100vh;

    background-color: chartreuse;
`